import { Eyebrow } from './Eyebrow';
import { FileLink } from './FileLink';
import { TextLink } from './TextLink';

interface Props {
  id: string;
  title: string;
  eyebrow?: string;
  /**
   * A link at the bottom right. For a downloadable file set `file`: the
   * link then shows "· soon" until `href` exists.
   */
  action?: { label: string; href?: string; file?: boolean };
}

// About-page heading: eyebrow + h2 on the left, optional link bottom-right.
export function SectionHeading({ id, title, eyebrow, action }: Props) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-x-8 gap-y-3">
      <div>
        {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
        <h2 id={id} className="m-0 font-serif text-h2-about font-semibold text-balance text-navy-900">
          {title}
        </h2>
      </div>
      {action &&
        (action.file ? (
          <FileLink href={action.href} label={action.label} />
        ) : (
          <TextLink href={action.href ?? '/'}>{action.label}</TextLink>
        ))}
    </div>
  );
}
